import UpdateCard from "../../components/UpdateCard/UpdateCard";
import { updatesData } from "./updatesData";

const Updates = () => {
  return (
    <section className="relative py-24 px-4 scroll-mt-24 bg-[#4a6e69]">
      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-white/60 text-sm font-semibold tracking-widest uppercase mb-3">
            What's New
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Latest Updates
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {updatesData.map((update) => (
            <UpdateCard
              key={update.id}
              title={update.title}
              description={update.description}
              icon={update.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Updates;
